module.exports = __webpack_public_path__ + "static/media/thumbs_lagodigital_3.4e2b53cd.jpg";